// Stub for MaterialCommunityIcons to redirect to Expo vector icons
import { MaterialCommunityIcons } from '@expo/vector-icons';

export default MaterialCommunityIcons;
